module.exports = __webpack_public_path__ + "media/images/CO_linkedin-abcf815b.svg";